import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { DeleteChannelFlow } from "../schemas/schemas_0";
export { $Command };
export class DeleteChannelFlowCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("ChimeMessagingService", "DeleteChannelFlow", {})
    .n("ChimeSDKMessagingClient", "DeleteChannelFlowCommand")
    .sc(DeleteChannelFlow)
    .build() {
}
